import React, { useEffect, useRef, useState } from "react";
import { ChevronDown, Check, Star } from "lucide-react";

const FLAGS = [
  { key: "is_new", label: "Novedad (sección Novedades del Inicio)" },
  { key: "is_highlighted", label: "Destacar en su sección (recuadro grande)" },
  { key: "is_featured", label: "Home · destacado" },
  { key: "is_top", label: "Lo más top" },
];
export const SECTIONS = [
  { key: "remix", label: "Remixes" },
  { key: "mashup", label: "Mashups" },
  { key: "original", label: "Originales" },
  { key: "pool", label: "Pool" },
];

export const sectionsToForm = (sections) => (sections || []).join(",");

export function HighlightSelect({ value, onChange, category, genres = [], testid = "highlight", small }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    const close = (e) => ref.current && !ref.current.contains(e.target) && setOpen(false);
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);
  const sections = value.sections || [];
  const hg = value.highlight_genres || [];
  const toggleGenre = (g) => onChange({ ...value, highlight_genres: hg.includes(g) ? hg.filter((x) => x !== g) : [...hg, g] });
  const activeLabels = [
    ...FLAGS.filter((o) => value[o.key]).map((o) => o.label),
    ...SECTIONS.filter((s) => sections.includes(s.key)).map((s) => s.label),
    ...hg.map((g) => `Género ${g}`),
  ];
  const toggleFlag = (key) => onChange({ ...value, [key]: !value[key] });
  const toggleSection = (key) => onChange({ ...value, sections: sections.includes(key) ? sections.filter((x) => x !== key) : [...sections, key] });

  const Item = ({ checked, disabled, onClick, label, testKey, hint }) => (
    <button type="button" onClick={onClick} disabled={disabled} data-testid={`${testid}-option-${testKey}`}
      className={`w-full flex items-center gap-2.5 px-2.5 py-2 text-xs text-left rounded-lg transition-colors hover:bg-white/[0.04] disabled:opacity-50 ${checked ? "text-white" : "text-white/60"}`}>
      <span className={`w-4 h-4 rounded-md border flex items-center justify-center transition-colors ${checked ? "bg-red-600 border-red-600" : "border-white/20 bg-black/30"}`}>{checked && <Check className="w-3 h-3 text-white" />}</span>
      <span className="flex-1">{label}</span>
      {hint && <span className="font-mono text-[9px] uppercase tracking-widest text-white/30">{hint}</span>}
    </button>
  );

  return (
    <div ref={ref} data-testid={`${testid}-select`}>
      <button type="button" onClick={() => setOpen((x) => !x)} data-testid={`${testid}-toggle`}
        className={`flex items-center gap-2 rounded-lg border px-3 ${small ? "py-1.5 text-xs" : "py-2 text-sm"} w-full text-left transition-colors ${activeLabels.length ? "border-red-800/60 bg-red-950/20 text-white" : "border-white/10 bg-[#16161D] text-white/60 hover:text-white"}`}>
        <Star className={`w-3.5 h-3.5 shrink-0 ${activeLabels.length ? "text-red-400" : "text-white/40"}`} />
        <span className="flex-1 truncate">{activeLabels.length ? `Destacar en: ${activeLabels.join(", ")}` : "Destacar en… (ninguno)"}</span>
        <ChevronDown className={`w-4 h-4 shrink-0 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="mt-1.5 w-full rounded-xl border border-white/10 bg-[#111116] shadow-xl overflow-hidden divide-y divide-white/5" data-testid={`${testid}-menu`}>
          <div className="p-1.5">
            <div className="px-2 pt-1 pb-1 font-mono text-[9px] uppercase tracking-[0.25em] text-red-500/80">Destacados</div>
            {FLAGS.map((o) => <Item key={o.key} checked={!!value[o.key]} onClick={() => toggleFlag(o.key)} label={o.label} testKey={o.key} />)}
          </div>
          {genres.length > 0 && (
            <div className="p-1.5">
              <div className="px-2 pt-1 pb-1 font-mono text-[9px] uppercase tracking-[0.25em] text-red-500/80">Destacar dentro del género</div>
              {genres.map((g) => <Item key={g} checked={hg.includes(g)} onClick={() => toggleGenre(g)} label={g} testKey={`genre-${g.toLowerCase().replace(/\s+/g, "-")}`} />)}
            </div>
          )}
          <div className="p-1.5">
            <div className="px-2 pt-1 pb-1 font-mono text-[9px] uppercase tracking-[0.25em] text-red-500/80">Secciones del menú · también aparece en</div>
            {SECTIONS.map((s) => (
              <Item key={s.key} checked={sections.includes(s.key)}
                onClick={() => toggleSection(s.key)} label={s.label} testKey={s.key} hint={s.key === category ? "su sección" : null} />
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
